import axios from "axios";

export interface ISavePaymentDetailsOnFullAppFormEvent {
    transaction: {
        id: string;
    };
    formData: {
        iban: string;
        bic: string;
    };
}

export const savePaymentDetails = async (transactionId: string, formValues:
    {
        iban: string;
        bic: string;
    }) => {

    const body: ISavePaymentDetailsOnFullAppFormEvent = {
        transaction: {
            id: transactionId,
        }, formData: {
            iban: formValues.iban,
            bic: formValues.bic,
        }
    };

    return axios.post(process.env.REACT_APP_SAVE_PAYMENT_DETAILS_FULL_APP_FORM_URL, body);
};
